import { Link, matchPath, useLocation } from "react-router";
import { useTranslate } from "ra-core";

import { cn } from "@/lib/utils";

/** Phone only: the phone bar has one Werkstatt button, these tabs reach the other pages. */
export const WorkshopTabs = () => {
  const { pathname } = useLocation();
  const translate = useTranslate();
  const tabs = [
    { to: "/workshop", match: "/workshop/*", label: "Entwürfe" },
    { to: "/ideas", match: "/ideas", label: "Ideen" },
    {
      to: "/funding-list",
      match: "/funding-list",
      label: translate("crm.funding_list.menu"),
    },
  ];
  return (
    <nav
      aria-label="Werkstatt"
      className="flex gap-1 border-b text-sm md:hidden"
    >
      {tabs.map((t) => {
        const active = !!matchPath(t.match, pathname);
        return (
          <Link
            key={t.to}
            to={t.to}
            aria-current={active ? "page" : undefined}
            className={cn(
              "-mb-px border-b-2 px-3 py-2",
              active
                ? "border-primary font-medium text-primary"
                : "border-transparent text-muted-foreground",
            )}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
};
